import { useState } from 'react';

type UseViewOrderTabNavigationResult = {
    activeTab: string;
    setActiveTab: (key: string) => void;
    showTab: (key: any) => void;
    onTabSelect: (key: any) => void;
};

export function useViewOrderTabNavigation(
    history: any,
    match: any,
    location: any
): UseViewOrderTabNavigationResult {
    const [activeTab, setActiveTab] = useState('');

    const showTab = (key: any): void => {
        setActiveTab(key);
        history.push(`${match.url}/${key}${location.search}`);
    };

    const onTabSelect = (key: any): void => {
        setActiveTab(key);
        history.push(`${match.url}/${key}`);
    };

    return { activeTab, setActiveTab, showTab, onTabSelect };
}
